/* ============================================================
   CRO 05 - Stueckpreis bei Sets
   Angelegt: 31.08.2026

   Warum: Die Google-Ads-Kampagne bewirbt fast nur Sets. Gesucht
   wird aber "glutenfreies brot" oder "glutenfreier kuchen" -
   also ein einzelnes Produkt. Wer auf ein 3er-Set fuer 18,90 EUR
   kommt, sieht zuerst die grosse Zahl. Der Preis je Backmischung
   nimmt ihr die Wucht: 18,90 EUR wirken anders als 6,30 EUR pro
   Brot.

   Wie: snippets/meta-tags.liquid rendert auf Produktseiten mit
   gepflegtem Metafeld custom.set_stueckzahl das Objekt
   window.gkStueckpreis. Dieses Skript haengt den fertigen Text
   unter den Preisblock. Gerechnet wird in Liquid, nicht hier -
   so bleibt die Waehrungsformatierung die des Shops.

   Eingefuegt wird nach .product-tax-price (MwSt-/Versandzeile),
   nicht direkt nach dem Preis: Diese Zeile hat im Theme einen
   negativen oberen Rand von -10 px und wuerde sich sonst mit
   dem Stueckpreis ueberlappen.

   Gepflegt wird die Stueckzahl je Produkt unter
   Shopify Admin -> Produkte -> Metafelder ->
   "Set: Anzahl Backmischungen". Ohne Wert passiert nichts.
   Bei Portionsangaben ("Pizza fuer 2 Personen") bewusst leer
   lassen - dort waere ein Stueckpreis irrefuehrend.

   Rueckgaengig: diese Datei und den Block in meta-tags.liquid
   entfernen. Die Metafelder koennen bleiben.
   ============================================================ */

(function () {
  'use strict';

  var data = window.gkStueckpreis;
  if (!data || !data.text) return;

  function einfuegen() {
    if (document.querySelector('.gk-stueckpreis')) return true;

    // Bevorzugt hinter die MwSt-/Versandzeile, sonst hinter den Preis.
    var anker = document.querySelector('.product-tax-price') ||
                document.querySelector('[class*="section-price"]');
    if (!anker) return false;

    var el = document.createElement('div');
    el.className = 'gk-stueckpreis';
    el.textContent = data.text;
    anker.insertAdjacentElement('afterend', el);
    return true;
  }

  function start() {
    if (einfuegen()) return;
    // Der Preisblock wird je nach Variante nachgerendert.
    var versuche = 0;
    var timer = setInterval(function () {
      versuche++;
      if (einfuegen() || versuche > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
